import { defineMessages } from "react-intl";

const PREFIX = "Subscriptions.SubscriptionsSettings.Schedule";
export const messages = defineMessages({
  controlTime: {
    id: `${PREFIX}.control.time`,
    defaultMessage: "Time (GMT+2)",
  },
  controlDayOfWeek: {
    id: `${PREFIX}.control.dayOfWeek`,
    defaultMessage: "Day of the week",
  },
  controlDay: {
    id: `${PREFIX}.control.day`,
    defaultMessage: "Day",
  },
  controlMonthOfQuarter: {
    id: `${PREFIX}.control.monthOfQuarter`,
    defaultMessage: "Month of the quarter",
  },
  controlMonthOfHalfYear: {
    id: `${PREFIX}.control.monthOfHalfYear`,
    defaultMessage: "Month of the half-year",
  },
  controlMonth: {
    id: `${PREFIX}.control.month`,
    defaultMessage: "Month",
  },

  frequencyDaily: {
    id: `${PREFIX}.frequency.daily`,
    defaultMessage: "Daily",
  },
  frequencyWeekly: {
    id: `${PREFIX}.frequency.weekly `,
    defaultMessage: "Weekly",
  },
  frequencyMonthly: {
    id: `${PREFIX}.frequency.monthly `,
    defaultMessage: "Monthly",
  },
  frequencyQuarterly: {
    id: `${PREFIX}.frequency.quarterly`,
    defaultMessage: "Quarterly",
  },
  frequencySemiAnnually: {
    id: `${PREFIX}.frequency.semiAnnually`,
    defaultMessage: "Semi-annually",
  },
  frequencyAnnually: {
    id: `${PREFIX}.frequency.annually`,
    defaultMessage: "Annually",
  },

  Jan: {
    id: `${PREFIX}.Jan`,
    defaultMessage: "January",
  },
  Feb: {
    id: `${PREFIX}.Feb`,
    defaultMessage: "February",
  },
  Mar: {
    id: `${PREFIX}.Mar`,
    defaultMessage: "March",
  },
  Apr: {
    id: `${PREFIX}.Apr`,
    defaultMessage: "April",
  },
  May: {
    id: `${PREFIX}.May`,
    defaultMessage: "May",
  },
  Jun: {
    id: `${PREFIX}.Jun`,
    defaultMessage: "June",
  },
  Jul: {
    id: `${PREFIX}.Jul`,
    defaultMessage: "July",
  },
  Aug: {
    id: `${PREFIX}.Aug`,
    defaultMessage: "August",
  },
  Sep: {
    id: `${PREFIX}.Sep`,
    defaultMessage: "September",
  },
  Oct: {
    id: `${PREFIX}.Oct`,
    defaultMessage: "October",
  },
  Nov: {
    id: `${PREFIX}.Nov`,
    defaultMessage: "November",
  },
  Dec: {
    id: `${PREFIX}.Dec`,
    defaultMessage: "December",
  },

  Monday: {
    id: `${PREFIX}.Monday`,
    defaultMessage: "Monday",
  },
  Tuesday: {
    id: `${PREFIX}.Tuesday`,
    defaultMessage: "Tuesday",
  },
  Wednesday: {
    id: `${PREFIX}.Wednesday`,
    defaultMessage: "Wednesday",
  },
  Thursday: {
    id: `${PREFIX}.Thursday`,
    defaultMessage: "Thursday",
  },
  Friday: {
    id: `${PREFIX}.Friday`,
    defaultMessage: "Friday",
  },
  Saturday: {
    id: `${PREFIX}.Saturday`,
    defaultMessage: "Saturday",
  },
  Sunday: {
    id: `${PREFIX}.Sunday`,
    defaultMessage: "Sunday",
  },
});
